export enum SubscriberGroupSectionType {
  Details = 'details',
  Translations = 'translations',
  ExternalMembers = 'externalmembers',
  UserMembers = 'usermembers'
}
